import React from 'react';
import classNames from 'classnames';
import useDomainTestResponsesContext from 'hooks/useDomainTestResponsesContext';

const QuestionCell: React.FC<{
  question: any;
  num: number;
  closeModal: any;
}> = ({ question, num, closeModal }) => {
  const visited = question.status === 'visited';
  const answered = question.status === 'answered';
  const { dispatch } = useDomainTestResponsesContext();
  return (
    <div
      onClick={() => {
        dispatch({
          type: 'UPDATE_CURRENT_QUESTION',
          payload: num - 1,
        });
        closeModal && closeModal();
      }}
      className={classNames(
        'bg-gradient-to-t from-gray-100 rounded text-center py-1 px-2 cursor-pointer',
        { 'to-bgIndigo': answered },
        { 'to-red-400': visited },
        { 'bg-gray-100': !answered && !visited }
      )}
    >
      {num}
    </div>
  );
};

export default QuestionCell;
